/*
 * dashboard (page)
 */
import { useDevMode } from "@psychology/dev"
import { Container, PageHeader, Page } from "@psychology/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { DashboardCard } from "../components/dashboard-card"
import { getEnabledFeatures } from "../config/features"
import { authPageLoader } from "../utils/auth.utils"

export const Route = createFileRoute("/dashboard")({
	component: DashboardPage,
	loader: authPageLoader,
})

function DashboardPage() {
	const { t } = useTranslation()
	const { devMode } = useDevMode()
	const features = getEnabledFeatures({ devMode })

	return (
		<Page>
			<Container width={"xxxl"} padding={"lg"} gap={"lg"}>
				<PageHeader title={"Psychology Dashboard"} />

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					{features.map((feature) => (
						<DashboardCard
							key={feature.key}
							title={t(feature.titleKey)}
							description={t(feature.descriptionKey)}
							to={feature.to}
							icon={<feature.icon className="w-8 h-8" />}
							gradient={feature.gradient}
							badge={feature.Badge ? <feature.Badge /> : undefined}
						/>
					))}
				</div>
			</Container>
		</Page>
	)
}
